// Total words across public/vocab-data/n1-n5.json. Kept as a constant so the
// homepage progress bar doesn't have to download every level's word list just
// to count them - vocabularyTotal.test.ts fails if the data files drift.
export const VOCABULARY_TOTAL = 8267;
